import { AdminIcon, AuditIcon, CatalogueIcon, DirectoryIcon, RoutingIcon, SettingsIcon, SlaIcon, TeamsIcon, UserIcon } from '../../app/icons';

/**
 * The nine admin sections, in one place: the sidebar's collapsible "Admin"
 * group (nav.ts) and `AdminLayout`'s tab strip both render from this list,
 * so they can never disagree about what exists or what it's called.
 */
export const ADMIN_SECTIONS = [
  { value: 'users', label: 'Users', path: '/admin/users', icon: UserIcon },
  { value: 'roles', label: 'Roles & Permissions', path: '/admin/roles', icon: AdminIcon },
  { value: 'teams', label: 'Teams', path: '/admin/teams', icon: TeamsIcon },
  { value: 'directory', label: 'Directory', path: '/admin/directory', icon: DirectoryIcon },
  { value: 'catalogue', label: 'Catalogue', path: '/admin/catalogue', icon: CatalogueIcon },
  { value: 'sla', label: 'SLA', path: '/admin/sla', icon: SlaIcon },
  { value: 'routing', label: 'Routing', path: '/admin/routing', icon: RoutingIcon },
  { value: 'settings', label: 'Settings', path: '/admin/settings', icon: SettingsIcon },
  { value: 'audit-log', label: 'Audit log', path: '/admin/audit-log', icon: AuditIcon },
] as const;

